module.exports = __webpack_public_path__ + "img/img-8@2x.504adb15.png";